<div class="container-fluid">
    <mat-toolbar class="toolbar-bg-blue">
        <h2>Create Organization</h2>
        <div class="forModalClose">
            <span (click)="cancel()">X</span>
        </div>

    </mat-toolbar>
    <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="isShowAlert">
        <b> Organization created successfully.</b>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="orgForm" #myForm="ngForm" (ngSubmit)="orgFormSubmit()">

        <mat-form-field>
            <mat-label>Name</mat-label>
            <input type="text" formControlName="name" matInput>
            <mat-error *ngIf="orgFormValidate?.name?.errors?.required">This field is required.</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Plan</mat-label>
            <mat-select formControlName="int_plan_id">
                <mat-option *ngFor="let int_plan of  int_plans;" [value]="int_plan?.id">{{int_plan?.name}} - {{int_plan?.price}}</mat-option>
            </mat-select>
            <mat-error *ngIf="orgFormValidate?.int_plan_id?.errors?.required">This field is required.</mat-error>
        </mat-form-field>

        <div class="footer-block text-center">
            <div class="button-group">
                <button type="submit" mat-raised-button class="btn-int-blue">Create </button>
            </div>
        </div>
    </form>
</div>